import { useQuery } from "@msuite/ui/query";
import { responseHandler } from "@msuite/ui/utils";
import type { Enums, TableTypesTable } from "@msuite/utils/types";
import { client } from "@/hono";

/**
 * This hook is used as a wrapper to call the api endpoint to get the ticket types.
 * @returns
 */
export function useTableTypes(
	tableTypesTable: TableTypesTable,
	state: Enums<"ticketTypeState">[] = ["active"],
) {
	/** Hooks */

	/** Query */
	const query = useQuery({
		queryKey: ["table-types", tableTypesTable, ...state],
		queryFn,
		staleTime: 10_000 * 60 * 5, // 5 minutes
	});

	/** Functions */
	async function queryFn() {
		const response = await client.organizations["table-types"][":tableTypesTable"].$get({
			query: { state },
			param: {
				tableTypesTable,
			},
		});
		const data = await responseHandler(response);
		const tableTypes = data.tableTypes;
		return { tableTypes };
	}

	/** Return */
	return { ...query, tableTypes: query.data?.tableTypes, queryFn };
}
